import { getCaptchaImage, login as loginApi, getInfo, getRouters, logout as logoutApi } from '@/api/auth'
import { ROLE_INFO } from '@/utils/permissions'

const state = () => ({
  isLoggedIn: false,
  role: null,
  name: '',
  avatar: '',
  token: localStorage.getItem('token') || '',
  userInfo: {},
  routers: [],
  accessibleRoutes: [],
  permissions: {}
})

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  isAdmin: state => state.role === 'super_admin' || state.role === 'china_admin',
  isSuperAdmin: state => state.role === 'super_admin',
  isChinaAdmin: state => state.role === 'china_admin',
  isWorker: state => state.role === 'worker',
  userRole: state => state.role,
  userName: state => state.name,
  userAvatar: state => state.avatar,
  token: state => state.token,
  userInfo: state => state.userInfo,
  routers: state => state.routers,
  accessibleRoutes: state => state.accessibleRoutes,
  permissions: state => state.permissions,
  statusPermissions: state => state.permissions.statusPermissions || {},
  fieldVisibility: state => state.permissions.fieldVisibility || {}
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },

  SET_LOGIN(state, { role, name, avatar, userInfo, permissions }) {
    state.isLoggedIn = true
    state.role = role
    state.name = name || (ROLE_INFO[role] ? ROLE_INFO[role].name : '')
    state.avatar = avatar || (ROLE_INFO[role] ? ROLE_INFO[role].avatar : '')
    state.userInfo = userInfo || {}
    state.permissions = permissions || {}
  },

  SET_USER_INFO(state, info) {
    state.userInfo = info
    if (info.user) {
      state.name = info.user.userName || info.user.nickName || state.name
      state.avatar = info.user.avatar || state.avatar
      state.role = info.user.role || state.role

      if (info.user.permissions) {
        state.permissions = info.user.permissions
      }

      if (info.user.permissions?.routes) {
        state.accessibleRoutes = info.user.permissions.routes
      }
    }

    if (!state.role && info.roles && info.roles.length > 0) {
      if (info.roles.includes('admin') || info.roles.includes('super')) {
        state.role = 'super_admin'
      } else {
        state.role = 'worker'
      }
    }
  },

  SET_LOGOUT(state) {
    state.isLoggedIn = false
    state.role = null
    state.name = ''
    state.avatar = ''
    state.token = ''
    state.userInfo = {}
    state.routers = []
    state.accessibleRoutes = []
    state.permissions = {}
    localStorage.removeItem('token')
  },

  SET_ROUTERS(state, routers) {
    state.routers = routers
    const routes = []
    function extractPaths(list) {
      if (!list || !list.length) return
      list.forEach(item => {
        if (item.path) {
          routes.push(item.path)
        }
        if (item.children && item.children.length) {
          extractPaths(item.children)
        }
      })
    }
    extractPaths(routers)
    state.accessibleRoutes = routes.length > 0 ? routes : state.accessibleRoutes
  }
}

const actions = {
  fetchCaptcha() {
    return getCaptchaImage()
  },

  async login({ commit, dispatch }, payload) {
    const res = await loginApi({
      username: payload.username,
      password: payload.password,
      code: payload.code,
      uuid: payload.uuid
    })

    const token = res.token
    commit('SET_TOKEN', token)

    try {
      const info = await dispatch('fetchUserInfo')
      let role = 'worker'
      let name = payload.username
      let avatar = ''
      let permissions = {}

      if (info && info.user) {
        role = info.user.role || role
        name = info.user.userName || info.user.nickName || name
        avatar = info.user.avatar || avatar
        permissions = info.user.permissions || {}
      }

      commit('SET_LOGIN', { role, name, avatar, userInfo: info, permissions })

      try {
        await dispatch('fetchRouters')
      } catch (e) {
        console.warn('获取路由菜单失败:', e)
      }
    } catch (e) {
      const role = payload.username === 'admin' ? 'super_admin' : 'worker'
      const info = ROLE_INFO[role]
      commit('SET_LOGIN', { role, name: info.name, avatar: info.avatar, userInfo: {}, permissions: {} })
    }

    return res
  },

  async fetchUserInfo({ commit }) {
    const info = await getInfo()
    commit('SET_USER_INFO', info)
    return info
  },

  async fetchRouters({ commit }) {
    const routers = await getRouters()
    commit('SET_ROUTERS', routers || [])
    return routers
  },

  async logout({ commit }) {
    try {
      await logoutApi()
    } catch (e) {
    }
    commit('SET_LOGOUT')
  }
}

export default { namespaced: true, state, getters, mutations, actions }